import { appStyles, appThemes, baseAppStyle } from "../js/config/appTheme";
export const getAppThemeName = () => appThemes[process.env.MIX_APP_PROJECT] || 'invoned';
export const getAppTheme = () => {
    const theme = getAppThemeName();
    return Object.assign(Object.assign({}, baseAppStyle), (appStyles[theme] || {}));
};
export const getLogoForTheme = () => getAppTheme().logo;
